export default "__VITE_ASSET__ipp9hqOq__"